export const UKRAINIAN_REGIONS = new Map([
  [
    "Kyiv Oblast",
    {
      mainCity: "Kyiv",
      cities: ["Kyiv", "Bila Tserkva", "Brovary", "Irpin", "Fastiv"],
    },
  ],
  [
    "Kharkiv Oblast",
    {
      mainCity: "Kharkiv",
      cities: ["Kharkiv", "Izium", "Kupiansk", "Chuhuiv"],
    },
  ],
  [
    "Odesa Oblast",
    {
      mainCity: "Odesa",
      cities: [
        "Odesa",
        "Odessa",
        "Izmail",
        "Bilhorod-Dnistrovskyi",
        "Chornomorsk",
      ],
    },
  ],
  [
    "Dnipropetrovsk Oblast",
    {
      mainCity: "Dnipro",
      cities: ["Dnipro", "Kryvyi Rih", "Kamianske", "Novomoskovsk"],
    },
  ],
  [
    "Zaporizhzhia Oblast",
    {
      mainCity: "Zaporizhzhia",
      cities: ["Zaporizhzhia", "Melitopol", "Berdiansk", "Enerhodar"],
    },
  ],
  [
    "Lviv Oblast",
    { mainCity: "Lviv", cities: ["Lviv", "Drohobych", "Stryi", "Truskavets"] },
  ],
  [
    "Mykolaiv Oblast",
    { mainCity: "Mykolaiv", cities: ["Mykolaiv", "Pervomaisk", "Yuzhne"] },
  ],
  [
    "Donetsk Oblast",
    {
      mainCity: "Donetsk",
      cities: ["Donetsk", "Mariupol", "Kramatorsk", "Sloviansk"],
    },
  ],
  [
    "Luhansk Oblast",
    { mainCity: "Luhansk", cities: ["Luhansk", "Sievierodonetsk", "Alchevsk"] },
  ],
  [
    "Vinnytsia Oblast",
    { mainCity: "Vinnytsia", cities: ["Vinnytsia", "Khmilnyk", "Zhmerynka"] },
  ],
  [
    "Kherson Oblast",
    { mainCity: "Kherson", cities: ["Kherson", "Nova Kakhovka", "Kakhovka"] },
  ],
  [
    "Poltava Oblast",
    { mainCity: "Poltava", cities: ["Poltava", "Kremenchuk", "Lubny"] },
  ],
  [
    "Chernihiv Oblast",
    { mainCity: "Chernihiv", cities: ["Chernihiv", "Nizhyn", "Pryluky"] },
  ],
  [
    "Cherkasy Oblast",
    { mainCity: "Cherkasy", cities: ["Cherkasy", "Uman", "Smila"] },
  ],
  ["Sumy Oblast", { mainCity: "Sumy", cities: ["Sumy", "Konotop", "Shostka"] }],
  [
    "Zhytomyr Oblast",
    { mainCity: "Zhytomyr", cities: ["Zhytomyr", "Berdychiv", "Korosten"] },
  ],
  [
    "Khmelnytskyi Oblast",
    {
      mainCity: "Khmelnytskyi",
      cities: ["Khmelnytskyi", "Kamianets-Podilskyi", "Shepetivka"],
    },
  ],
  [
    "Chernivtsi Oblast",
    { mainCity: "Chernivtsi", cities: ["Chernivtsi", "Storozhynets"] },
  ],
  [
    "Rivne Oblast",
    { mainCity: "Rivne", cities: ["Rivne", "Dubno", "Kostopil"] },
  ],
  [
    "Ivano-Frankivsk Oblast",
    {
      mainCity: "Ivano-Frankivsk",
      cities: ["Ivano-Frankivsk", "Kolomyia", "Kalush"],
    },
  ],
  [
    "Kirovohrad Oblast",
    {
      mainCity: "Kropyvnytskyi",
      cities: ["Kropyvnytskyi", "Oleksandriia", "Svitlovodsk"],
    },
  ],
  [
    "Ternopil Oblast",
    { mainCity: "Ternopil", cities: ["Ternopil", "Chortkiv", "Kremenets"] },
  ],
  ["Volyn", { mainCity: "Lutsk", cities: ["Lutsk", "Kovel", "Novovolynsk"] }],
  [
    "Zakarpattia Oblast",
    { mainCity: "Uzhhorod", cities: ["Uzhhorod", "Mukachevo", "Berehove"] },
  ],
  // First-level units that are not oblasts. Listed so segments can name them
  // (the popunder lane maps the ISO codes RTB sends onto these names).
  ["Kyiv", { mainCity: "Kyiv", cities: ["Kyiv"] }],
  [
    "Crimea",
    { mainCity: "Simferopol", cities: ["Simferopol", "Kerch", "Yevpatoriia"] },
  ],
  ["Sevastopol", { mainCity: "Sevastopol", cities: ["Sevastopol"] }],
]);

// ISO 3166-2:UA code -> the region name above, for traffic that reports
// subdivisions as codes (OpenRTB device.geo.region). Covers every first-level
// unit, so a known code always resolves to a name a segment can use.
export const UA_ISO_REGIONS = new Map([
  ["UA-05", "Vinnytsia Oblast"],
  ["UA-07", "Volyn"],
  ["UA-09", "Luhansk Oblast"],
  ["UA-12", "Dnipropetrovsk Oblast"],
  ["UA-14", "Donetsk Oblast"],
  ["UA-18", "Zhytomyr Oblast"],
  ["UA-21", "Zakarpattia Oblast"],
  ["UA-23", "Zaporizhzhia Oblast"],
  ["UA-26", "Ivano-Frankivsk Oblast"],
  ["UA-30", "Kyiv"],
  ["UA-32", "Kyiv Oblast"],
  ["UA-35", "Kirovohrad Oblast"],
  ["UA-40", "Sevastopol"],
  ["UA-43", "Crimea"],
  ["UA-46", "Lviv Oblast"],
  ["UA-48", "Mykolaiv Oblast"],
  ["UA-51", "Odesa Oblast"],
  ["UA-53", "Poltava Oblast"],
  ["UA-56", "Rivne Oblast"],
  ["UA-59", "Sumy Oblast"],
  ["UA-61", "Ternopil Oblast"],
  ["UA-63", "Kharkiv Oblast"],
  ["UA-65", "Kherson Oblast"],
  ["UA-68", "Khmelnytskyi Oblast"],
  ["UA-71", "Cherkasy Oblast"],
  ["UA-74", "Chernihiv Oblast"],
  ["UA-77", "Chernivtsi Oblast"],
]);
